export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/apps/cooking_lessons.afb6578.svg";